export const AppUIVersion = 4;
export const AppAPIVersion = 2;
export const AppVersionCode = 900;
export const MedicineDataVersion = 2;

export const AppGUID = 'flutter-';

export const UserDummyId = -2;
export const EntityTypeUser = 3;
export const EntityTypePharmacy = 5;

export const Ampersand = '\x26'; // &
export const CopyRight = '\xA9'; // ©
export const IndiaRupee = '\u20B9'; // ₹

export const OMSWAChatbotNumber = '919024467365';

export const ShowA2HSTimeout = 3 * 24 * 60 * 60 * 1000


export const minDealsToShowAllBtn = 10

export const ServiceEndpoints = {
    'vega': { 'oms': 'https://oms.medcords.com/', 'api': 'https://aayuapp-api.medcords.com/', 'aayu': 'https://aayu.medcords.com/', 'resources': null },
    'betel': { 'oms': 'https://oms.mcords.co.in/', 'api': 'https://aayuapp-api.mcords.co.in/', 'aayu': 'https://aayu.mcords.co.in/userv2/', 'resources': null },
    'npm': { 'oms': 'https://oms.mcords.co.in/', 'api': 'https://aayuapp-api.mcords.co.in/', 'aayu': 'https://aayu.mcords.co.in/userv2/', 'resources': 'http://127.0.0.1:8081/assets' },
    'lap': { 'oms': 'https://oms.mcords.co.in/', 'api': 'https://aayuapp-api.mcords.co.in/', 'aayu': 'https://aayu.mcords.co.in/userv2/', 'resources': 'https://lap-static.mcords.co.in/assets' },
}

export const reactjsLogo = { uri: "https://reactjs.org/logo-og.png" };
export const WABaseURL = `https://wa.me/919024467365?text=`;
export const AayuCardVideoURL = 'https://www.youtube.com/watch?v=0MAkR2uda-k';
export const AAYUPlayStoreURL = 'https://getaayu.medcords.com/6QYe';
export const OMSPlayStoreURL = 'https://play.google.com/store/apps/details?id=com.medcords.rurallite&utm_source=aayu-web';
export const AayuCardYTVideoIcon = 'https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Faayu_card_v2%2Faayu_revamp_intro_icon_svg_new_Jan_23.svg?alt=media&token=464bf0df-7483-4dce-99cf-e5849f7ced4f';

export const ActivityType = {
    order: 'oms',
    consultation: 'consultation'
}

export const ServiceName = {
    order: 'Order Medicine',
    consultation: 'Remote Consultation',
    followup: 'Followup',
    acs: 'Aayu Card Subscription',
    prime_membership: 'Prime Membership' // Only for chemist.
}

export const OrderType = {
    precriptions: 2,
    medicines: 3,
    products: 4
}